// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.seal-container .ivu-spin-fix {\r\n  background-color: rgba(255,255,255,.9) !important;\n}\r\n", ""]);
// Exports
module.exports = exports;
